import '../App.css';
import QuestionAdhd from '../components/QuestionAdhd';
import { useState, useRef, useEffect, useCallback } from 'react';
import { useNavigate } from "react-router-dom";

function App() {

    const wrapperRef = useRef();
    const lastSentHeight = useRef(0);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const sendHeight = useCallback(() => {
        const newHeight = wrapperRef.current?.scrollHeight;
        if (
            newHeight &&
            Math.abs(newHeight - lastSentHeight.current) > 20
        ) {
            window.parent.postMessage(
                {
                    type: "setHeight",
                    height: newHeight,
                    isSubmitted: isSubmitted,
                },
                "*"
            );
            lastSentHeight.current = newHeight;
        }
    }, [isSubmitted]);

useEffect(() => {
    function handleResize() {
        sendHeight();
    }
    window.addEventListener('resize', handleResize);
    // Send initial height
    sendHeight();
    return () => {
        window.removeEventListener('resize', handleResize);
    };
}, [sendHeight]);
  const questions = [
      { question: "1. Hur ofta har du svårigheter med att avsluta de sista detaljerna i en uppgift/ett projekt när de mer krävande momenten har avklarats?", category: "Ouppmärksamhet" },
      { question: "2. Hur ofta har du svårigheter med att få ordning på saker och ting när du ska utföra en uppgift som kräver organisation?", category: "Ouppmärksamhet" },
      { question: "3. Hur ofta har du problem att komma ihåg avtalade möten, t ex läkarbesök, eller åtaganden", category: "Ouppmärksamhet" },
      { question: "4. Hur ofta händer det att du undviker eller skjuter på att sätta igång med en uppgift som kräver mycket tankemöda?", category: "Ouppmärksamhet" },
      { question: "5. Hur ofta händer det att du sitter och plockar med något, eller skruvar på dig och rör händer eller fötter när du är tvungen att sitta en längre stund?", category: "Hyperaktivitet" },
      { question: "6. Hur ofta känner du dig överaktiv och tvungen att hålla igång, som om du gick på högvarv?", category: "Hyperaktivitet" },
      { question: "7. Hur ofta händer det att du gör slarvfel när du arbetar med en tråkig eller svår uppgift?", category: "Ouppmärksamhet" },
      { question: "8. Hur ofta händer det att du har svårt att hålla kvar uppmärksamheten när du utför tråkigt eller monotont arbete?", category: "Ouppmärksamhet" },
      { question: "9. Hur ofta händer det att du har svårt att koncentrera dig på vad folk säger, även när de pratar direkt till dig?", category: "Ouppmärksamhet" },
      { question: "10. Hur ofta händer det att du förlägger eller har svårt att hitta saker hemma eller på arbetet?", category: "Ouppmärksamhet" },
      { question: "11. Hur ofta händer det att du distraheras av händelser eller ljud i din omgivning?", category: "Ouppmärksamhet" },
      { question: "12. Hur ofta händer det att du lämnar din plats under möten eller i andra situationer där du förväntas sitta kvar?", category: "Hyperaktivitet" },
      { question: "13. Hur ofta händer det att du känner dig rastlös eller har svårt att vara stilla?", category: "Hyperaktivitet" },
      { question: "14. Hur ofta händer det att du har svårt att gå ner i varv och koppla av när du har en stund över?", category: "Hyperaktivitet" },
      { question: "15. Hur ofta händer det att du kommer på dig med att prata för mycket i sociala sammanhang?", category: "Hyperaktivitet" },
      { question: "16. Hur ofta händer det att du avslutar meningar åt dem du talar med, innan de själva hinner avsluta dem?", category: "Hyperaktivitet" },
      { question: "17. Hur ofta händer det att du har svårt att vänta på din tur i situationer då det krävs?", category: "Hyperaktivitet" },
      { question: "18. Hur ofta händer det att du avbryter/stör andra när de är upptagna?", category: "Hyperaktivitet" },
  ];

const [scores, setScores] = useState({ Ouppmärksamhet: 0, Hyperaktivitet: 0 });
const [answers , setAnswers] = useState([]);
const [error , setError] = useState('');

const navigate = useNavigate();

  const handleAnswer = (category, points, index) => {
      setScores((prevScores) => ({
          ...prevScores,
          [category]: prevScores[category] + points,
      }));

    setAnswers((prevAnswers) => {
        if (!prevAnswers.includes(index)) {
            return [...prevAnswers, index];
        }
        return prevAnswers;
    });
};


  const handleSubmit = () => {
        if (answers.length !== questions.length) {
        setError("Du måste svara på alla frågor innan du kan skicka in testet.");
        return;
    }
      setIsSubmitted(true);
      localStorage.setItem('scores', JSON.stringify(scores));
      localStorage.setItem('totalScores', JSON.stringify(totalScores));
        setTimeout(() => {
            navigate("/result", { state: { scores, totalScores } });
        }, 300);
  };

    const totalScores = {
    Ouppmärksamhet: questions.filter((q) => q.category === "Ouppmärksamhet").length * 4,
    Hyperaktivitet: questions.filter((q) => q.category === "Hyperaktivitet").length * 4,
  };

  return (
      <div className="questionnaire-adhd" ref={wrapperRef}>
          <header className="App-header">
                <>
                    <div className="questionnaire">
                        {questions.map((q, index) => (
                            <QuestionAdhd
                                key={index}
                                question={q.question}
                                category={q.category}
                                index={index}
                                onAnswer={handleAnswer}
                            />
                        ))}
                        {error && <p className="error">{error}</p>}
                        <div className='submit-container'>
                            <button onClick={handleSubmit} className="submit-button">
                                Tolka mina svar
                            </button>
                        </div>
                    </div>
                </>
            </header>
        </div>
    );
}

export default App;
